import React, { InputHTMLAttributes } from 'react'
import { useTranslation } from 'next-i18next'

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    label?: string
    name: string
    subtext?: string
    optional?: boolean
}

const Input: React.FC<InputProps> = React.forwardRef<HTMLInputElement, InputProps>(
    (
        {
            type = 'text',
            className = '',
            label,
            name,
            prefix,
            subtext,
            disabled = false,
            optional = false,
            required = false,
            ...restProps
        },
        ref
    ) => {
        const { t } = useTranslation()

        return (
            <div className="w-full">
                <div className={`${optional ? 'flex justify-between' : ''}`}>
                    {label && (
                        <label htmlFor={name} className="block text-sm font-medium text-gray-700">
                            {label}
                            {required}
                        </label>
                    )}
                    {optional && <span className="text-sm text-gray-500 capitalize">{t('optional')}</span>}
                </div>
                <div className={`${label ? 'mt-1' : ''} flex rounded-md shadow-sm`}>
                    {prefix && (
                        <span className="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 text-sm">
                            {prefix}
                        </span>
                    )}
                    <input
                        ref={ref}
                        id={name}
                        name={name}
                        type={type}
                        disabled={disabled}
                        required={required}
                        className={`${
                            disabled ? 'bg-gray-100' : ''
                        } shadow-sm block w-full sm:text-sm focus:border-crusta-500 focus:outline-none focus:ring-crusta-500 ${className}
                    ${prefix ? 'rounded-r-md' : 'rounded-md'}`}
                        {...restProps}
                    />
                </div>
                {subtext && (
                    <div>
                        <p className="mt-2 text-sm text-gray-500">{subtext}</p>
                    </div>
                )}
            </div>
        )
    }
)

export default Input
